import Layout from 'components/Layout';
import NotFound from 'components/NotFound';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div>
      <Layout
        title={t(`main.meta.pageTitle`)}
        description={t(`main.meta.metaDescription`)}
        indexed={false}
      >
        {<NotFound />}
      </Layout>
    </div>
  );
}
